import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const MIN_LEFT = 3;
export function ScarcityBar() {
  const [left, setLeft] = useState(9);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(v => v > MIN_LEFT ? v - 1 : v);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - left) / TOTAL_SPOTS * 100;
  return <div className="w-full rounded-2xl bg-alert/10 p-4 ring-1 ring-alert/40" data-id="element-271" data-mp="2b5fa2h20qsva">
      <div className="mb-2.5 flex items-center justify-between gap-3" data-id="element-272" data-mp="2g6mj0jfwdy3j">
        <p className="flex items-center gap-1.5 text-sm font-extrabold uppercase tracking-wide text-cream" data-id="element-273" data-mp="226lgkzjziily">
          <FlameIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-274" data-mp="274dafz46wess" />
          Only {left} spots left
        </p>
        <span className="text-sm font-bold tabular-nums text-alert" data-id="element-275" data-mp="g0cbzqh0yn1">{Math.round(filled)}% claimed</span>
      </div>
      <div className="h-4 w-full overflow-hidden rounded-full bg-ink ring-1 ring-line" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-276" data-mp="5da07ay7p28r">
        <div className="h-full rounded-full bg-alert transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-277" data-mp="3dbmwklc9njdh" />
      </div>
      <p className="mt-2.5 text-xs leading-snug text-muted" data-id="element-278" data-mp="2knr0niuitvhr">
        When these last spots are claimed, the $27 promotional price will no longer be available.
      </p>
    </div>;
}